export default __webpack_public_path__ + "a90f6ef2cc6e594da8b30eaee04fafff.svg";